import { ProductList } from '@/models/props/ProductCardProps';

const BasketConfig: Pick<ProductList, 'pageSize'> & { checkoutMaxSize: number } = {
    pageSize: 50,
    checkoutMaxSize: 100
};

export default BasketConfig;
